import { Grid, Typography } from '@material-ui/core'
import { useConversationCardStyles } from './conversation-card.styles'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { PRIMARY_COLORS } from 'asterX-UI'

export const ConversationCard = ({
  label,
  description,
  color = PRIMARY_COLORS[700]
}) => {
  const classes = useConversationCardStyles()

  return (
    <div className={classes.card}>
      <Typography className={classes.description}>{description}</Typography>
      <Typography className={classes.label} style={{ color }}>
        {label}
      </Typography>
    </div>
  )
}
